import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store/ConfigureStore";
import { SnackbarProvider } from "notistack";
import { BrowserRouter } from "react-router-dom";
import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

// const store = ConfigureStore();
const notistackRef = React.createRef();
const onClickDismiss = (key) => () => {
  notistackRef.current.closeSnackbar(key);
};
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <>
    {/* <React.StrictMode> */}
    {/* <AzureAD provider={authProvider} forceLogin={true}> */}
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
              <SnackbarProvider
                ref={notistackRef}
                action={(key) => (
                  <Button onClick={onClickDismiss(key)}>
                    <CloseIcon style={{ color: "#fff" }} />
                  </Button>
                )}
                maxSnack={1}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
              >
                <App />
              </SnackbarProvider>
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </>
  /* </React.StrictMode> */
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

